export const API_PATH_apiWorkzoneItemGet = '/services/workzones-management/item';
